import { CoordsModel } from "@components/livemap/model/CoordsModel";
import { IVeriMapComponent } from "@directives/_map/veriMap/veriMapComponent/veriMap.component";
import { ITimelineEntry } from "@directives/_veri/v-timeline/v-timeline.component";
import { IVeriTableHeader, IVeriTableRow, IVeriTableRowCell } from "@directives/_veri/veriTable/veriTable.component";
import { VeriTableService } from "@directives/_veri/veriTable/veriTable.service";
import { IGoogleMapsMarker } from "@interfaces/IGoogleMapsMarkerOptions";
import { IUser } from "@interfaces/IUser";
import { IDateQueryOptions } from "@services/accelerometerRecord.service";
import { UserRole } from "@services/accountFeature.service";
import { AuthorizationService } from "@services/authorization.service";
import { CurrentUserService } from "@services/currentUser.service";
import { DateService, DateUnit } from "@services/date.service";
import { DisplayService, IDialogOptionsJson } from "@services/display.service";
import { DriverService } from "@services/driver.service";
import { DriverAssignmentService } from "@services/driverAssignment.service";
import { MapService } from "@services/map.service";
import { NavigationService } from "@services/navigation.service";
import { PlotService } from "@services/plot.service";
import { TranslationService } from "@services/translation.service";
import { UsersService } from "@services/users.service";
import { VehicleService } from "@services/vehicle.service";
import { IPolyline } from "@typings/google.maps.angular";
import * as angular from "angular";
import { AlertReviewStatus } from "src/app/main/modules/alerts/_enums/AlertReviewStatus.enums";
import { AlertCategory } from "src/app/main/modules/alerts/_enums/alerts.enums";
import { IAlertRule } from "src/app/main/modules/alerts/_models/alerts.interfaces";
import { IAlertResolutionCode } from "src/app/main/modules/alerts/_models/IAlertResolutionCode";
import { IAlertReviewEvent } from "src/app/main/modules/alerts/_models/IAlertReviewEvent";
import { IAlertReviewHistory } from "src/app/main/modules/alerts/_models/IAlertReviewHistory";
import { AlertReviewService, IReviewEventQueryOptions, IReviewHistoryQueryOptions } from "src/app/main/modules/alerts/_services/alert-review.service";
import { AlertRecordMaterialisationOptions, AlertsService, IAlertRecordQueryOptions } from "src/app/main/modules/alerts/_services/alerts.service";
import "./incidentDetail.component.scss";


class IncidentDetailComponentComponentController implements angular.IComponentController {
    loading = false;
    previousAlertsLoading = false;

    prevAlertsTableHeaders: IVeriTableHeader[];
    prevAlertsTableRows: IVeriTableRow[];

    alertRules: IAlertRule[];

    incidentId: number;

    incident: IAlertReviewHistory;
    previousAlerts: IAlertReviewHistory[];

    tempGraphStart: Date;
    tempGraphEnd: Date;

    timelineEntries: ITimelineEntry[] = [];

    category: string;
    subCategory: string;

    event: IAlertReviewEvent;
    status: AlertReviewStatus;
    resolution: IAlertResolutionCode;
    resolutionCodes: IAlertResolutionCode[];

    incidentResolutionCode: string;
    incidentDurationToResolve: string;
    incidentResolveByUser: string;
    incidentResolutionComment: string;

    statusString: string;
    statusClass: string;
    currentUser: IUser;
    isAuthorized: boolean;

    dateStartAndEndLabel: string;
    dateStartIsEqualToEnd = false;

    alertRaisedDateTime: Date;

    veriMap: IVeriMapComponent;
    alertPolyline: IPolyline;
    alertLocationMarker: IGoogleMapsMarker;
    endMapMarker: IGoogleMapsMarker;
    showMapMarkers: boolean = false;
    mapCenter: CoordsModel;

    formSubmitting = false;

    agreement = false;

    noteString: string;
    noteLoading = false;

    showTemperatureGraph = false;
    showGeofences = false;

    plotReasonText: string;

    AlertReviewStatus = AlertReviewStatus;

    showPreviousAlertsSidebar: boolean;

    static $inject = ["$q", "$scope", "$timeout", "alertReviewService", "alertsService", "currentUserService", "dateService", "driverService", "driverAssignmentService", "mapService", "plotService", "translationService", "usersService", "vehicleService", "veriTableService", "displayService", "navigationService", "authorizationService"];

    constructor(
        private readonly $q: angular.IQService,
        private readonly $scope: angular.IScope,
        private readonly $timeout: angular.ITimeoutService,
        private readonly alertReviewService: AlertReviewService,
        private readonly alertsService: AlertsService,
        private readonly currentUserService: CurrentUserService,
        private readonly dateService: DateService,
        private readonly driverService: DriverService,
        private readonly driverAssignmentService: DriverAssignmentService,
        private readonly mapService: MapService,
        private readonly plotService: PlotService,
        private readonly translationService: TranslationService,
        private readonly usersService: UsersService,
        private readonly vehicleService: VehicleService,
        private readonly veriTableService: VeriTableService,
        private readonly displayService: DisplayService,
        private readonly navigationService: NavigationService,
        private readonly authorizationService: AuthorizationService
    ) { }

    $onInit(): void {
        this.isAuthorized = this.authorizationService.isUserAuthorized([UserRole.History]);

        if (this.isAuthorized) {
            this.loadData();
        }

        this.currentUserService.getCurrentUser().then(user => {
            this.currentUser = user;
        });
    }

    selectedItemChanged(data): void {
        this.alertReviewService.openIncidentDetailsDialog(data);
    }

    openResolutionDialog($event): void {
        let dialogHTML = `<alert-review-dialog [incident]="$ctrl.incident" (add-alert-review-event)="$ctrl.onAlertReviewEventAdded($event); $ctrl.hide();" [status]="$ctrl.status"><alert-review-dialog>`;

        const dialogOptions: IDialogOptionsJson = {
            title: this.translationService.t('Alerts.ResolveIncident'),
            dialogHTML: dialogHTML,
            dialogId: `alertReviewDialog`,
            bindings: {
                incident: this.incident, status: this.status, onAlertReviewEventAdded: (alertReviewEvent: IAlertReviewEvent) => { this.onAlertReviewEventAdded(alertReviewEvent) }
            },
            event: $event,
            clickOutsideToClose: true,
            escapeToClose: true
        };

        this.displayService.showDialog(dialogOptions);
    }

    onAlertReviewEventAdded(alertReviewEvent: IAlertReviewEvent): void {
        this.loading = true;

        if (this.incident.Id === alertReviewEvent.AlertReviewHistoryId) {
            this.incident.latestAlertReviewEvent = alertReviewEvent;
            this.incident.EndTime = alertReviewEvent.CreatedTime;
        }

        this.alertReviewService.emitAlertReviewHistoryUpdate(this.incident);

        this.$timeout(() => {
            this.loadData();
        }, 1000);
    }

    mapIdle(veriMap: IVeriMapComponent): void {
        this.veriMap = veriMap;
    }

    openPreviousAlertsSidebar(): void {
        this.showPreviousAlertsSidebar = true;

        this.$scope.$applyAsync();
    }

    closePreviousAlertsSidebar(): void {
        this.showPreviousAlertsSidebar = false;

        this.$scope.$applyAsync();
    }

    // ---

    private loadData(): void {
        this.loading = true;

        const vehiclesPromise = this.vehicleService.getVehicles({ includeProbes: true, includePeripheralMappings: true });
        const driversPromise = this.driverService.getDrivers();
        const assignmentsPromise = this.driverAssignmentService.getDriverAssignments(true);
        const incidentPromise = this.alertReviewService.getAlertReviewHistory({ Id: this.incidentId, invalidateCache: true });
        const alertEventsPromise = this.alertReviewService.getAlertReviewEvents({ AlertReviewHistoryId: this.incidentId, invalidateCache: true });
        const usersPromise = this.usersService.getUsers({ includeAdmins: true, includeMappings: true });
        const resolutionCodesPromise = this.alertsService.getAlertResolutionCodes();

        this.$q.all([vehiclesPromise, driversPromise, assignmentsPromise, incidentPromise, alertEventsPromise, usersPromise, resolutionCodesPromise])
            .then(([vehicles, drivers, assignments, incident, alertEvents, users, resolutionCodes]) => {
                this.driverAssignmentService.mapDriversToVehicles(drivers, assignments, vehicles);
                this.incident = incident[0];
                this.resolutionCodes = resolutionCodes;
                this.alertReviewService.mapEventsToHistory(this.incident, alertEvents);
                this.alertReviewService.mapUsersToEvents(this.incident, users);
                this.alertReviewService.mapVehicleToHistory(this.incident, vehicles);
                this.getAlertRecords();
                this.getStatus();
                this.getPreviousAlertsForVehicle();
                this.navigationService.updateBreadcrumbNameResolver({ incidentName: this.incident.AlertRule?.Name });
            })
            .finally(() => {
                this.setupTimeline();
                this.setupPageElements();

                this.loading = false;
            });
    }

    private getPreviousAlertsForVehicle(): void {
        this.previousAlertsLoading = true;
        this.createPrevAlertsTableHeaders();

        const dateQueryOptions: IDateQueryOptions = {
            Start: this.dateService.addOrSubtractTime(new Date(), -14, DateUnit.Day),
            End: new Date()
        }

        const previousAlertsPromise = this.createPreviousAlertsPromise(dateQueryOptions);
        const alertEventsPromise = this.createAlertEventsPromise(dateQueryOptions);
        const alertRulesPromise = this.alertsService.getAlertRules();
        const alertRecordsPromise = this.createAlertRecordsPromise(dateQueryOptions);

        this.$q.all([previousAlertsPromise, alertEventsPromise, alertRulesPromise, alertRecordsPromise]).then(
            ([alerts, events, rules, records]) => {

                this.previousAlerts = alerts.filter(alert => {
                    return alert.Id !== this.incident.Id; // We don't want to include the current incident in the list
                });
                this.alertRules = rules;

                this.previousAlerts.forEach(alert => {
                    alert.AlertRecord = records.find(record => {
                        return record.Id === alert.AlertRecordId;
                    });
                    alert.AlertReviewEvents = events.filter(event => {
                        return event.AlertReviewHistoryId === alert.Id;
                    });
                });
                this.createPrevAlertsTableRows();
            }).finally(() => {
                this.navigationService.updateBreadcrumbNameResolver({ incidentName: this.incident.AlertRule?.Name });
                this.previousAlertsLoading = false;
            });
    }

    createAlertEventsPromise(dateQueryOptions: IDateQueryOptions) {
        const alertEventsQueryOptions = dateQueryOptions as IReviewEventQueryOptions;
        alertEventsQueryOptions.VehicleId = this.incident.VehicleId;

        return this.alertReviewService.getAlertReviewEvents(alertEventsQueryOptions);
    }

    createAlertRecordsPromise(dateQueryOptions: IDateQueryOptions) {
        const alertRecordQueryOptions = dateQueryOptions as IAlertRecordQueryOptions;
        alertRecordQueryOptions.MaterialisationOptions = AlertRecordMaterialisationOptions.WithMetadata;
        alertRecordQueryOptions.VehicleId = this.incident.VehicleId;
        alertRecordQueryOptions.invalidateCache = true;

        return this.alertsService.getAlertRuleRecordsUsingQueryOptions(alertRecordQueryOptions);
    }

    createPreviousAlertsPromise(dateQueryOptions: IDateQueryOptions) {
        const previousAlertQueryOptions = dateQueryOptions as IReviewHistoryQueryOptions;
        previousAlertQueryOptions.VehicleId = this.incident.VehicleId;
        previousAlertQueryOptions.invalidateCache = true;

        return this.alertReviewService.getAlertReviewHistory(previousAlertQueryOptions);
    }

    private createPrevAlertsTableHeaders() {
        this.prevAlertsTableHeaders = [
            this.veriTableService.createDateHeader(),
            { title: this.translationService.t('Alerts.Category'), sortable: true },
            { title: this.translationService.t('Alerts.Status'), sortable: true, width: 60 },
            { title: this.translationService.t('Alerts.Resolution'), sortable: true },
        ];
    }

    private createPrevAlertsTableRows() {
        this.prevAlertsTableRows = [];

        this.previousAlerts.forEach(historyItem => {
            this.prevAlertsTableRows.push({
                data: historyItem,
                cells: this.createPrevAlertsTableCells(historyItem)
            });
        });
    }

    private createPrevAlertsTableCells(historyItem: IAlertReviewHistory): IVeriTableRowCell[] {
        const status = this.translationService.tEnum(AlertReviewStatus, 'AlertReviewStatus', this.alertReviewService.getCurrentStatusOfHistoryItem(historyItem));
        const category = this.translationService.tEnum(AlertCategory, 'AlertCategory', this.alertReviewService.getAlertRuleCategory(historyItem, this.alertRules)) || 'N/A';
        const resolutionCode = historyItem.latestAlertReviewEvent ? this.resolutionCodes.find(c => c.Id === historyItem.latestAlertReviewEvent.ResolutionCodeId).Name : 'N/A';

        const cells: IVeriTableRowCell[] = [
            this.veriTableService.createDateTimeCell(historyItem.AlertRecord.ActionAtDataTimestamp || historyItem.CreatedTime),
            { contents: category },
            { contents: status },
            { contents: resolutionCode }
        ];

        return cells;
    }

    private setupPageElements() {

        switch (this.incident?.AlertRule?.Category) {
            case AlertCategory.TemperatureProfile:
            case AlertCategory.Transcan:
                this.setupTempGraph();
                break;
        }
    }

    private setupTempGraph() {
        this.showTemperatureGraph = true;
        this.tempGraphStart = this.dateService.addOrSubtractTime(this.incident.AlertRecord.TriggeredAtDataTimestamp, -60, DateUnit.Min);

        this.tempGraphEnd = this.incident.AlertRecord.ClosedAtDataTime ? this.dateService.addOrSubtractTime(this.incident.AlertRecord.ClosedAtDataTime, -60, DateUnit.Min) : this.dateService.addOrSubtractTime(new Date(), 10, DateUnit.Min);; //If temperature is still out of bounds we want the graph to show the start of the OOB to now
    }



    private getStatus() {

        if (this.incident.AlertReviewEvents && this.incident.AlertReviewEvents.length > 0) {
            let mostRecentEvent = this.incident.AlertReviewEvents.find(event => {
                return event.Id === this.incident.LatestAlertReviewEventId;
            });
            if (!mostRecentEvent) {
                mostRecentEvent = this.incident.AlertReviewEvents.slice(-1)[0];
            }
            this.status = mostRecentEvent.Status;
            this.statusString = this.translationService.tEnum(AlertReviewStatus, 'AlertReviewStatus', mostRecentEvent.Status);
        }
        else {
            this.status = AlertReviewStatus.Open;
            this.statusString = this.translationService.tEnum(AlertReviewStatus, 'AlertReviewStatus', 0);
        }
        this.statusClass = AlertReviewStatus[this.status].toLowerCase();
    }

    private getResolution(): void {

        this.resolution = this.resolutionCodes.find(code => code.Id === this.alertReviewService.getResolutionCode(this.incident));
        this.incidentResolutionCode = this.resolution?.Name || 'N/A';
        this.incidentDurationToResolve = this.alertReviewService.getDurationInAlarm(this.incident);
        this.incidentResolveByUser = this.alertReviewService.getResolvingUser(this.incident);
        this.incidentResolutionComment = this.alertReviewService.getResolutionComment(this.incident);
    }

    private getDateStartAndEndLabel() {
        this.alertRaisedDateTime = new Date(this.incident.StartTime);
        if (!this.incident.AlertRecord.ClosedAtDataTime) {
            const formattedStartDate = this.dateService.formatDate(this.incident.AlertRecord.TriggeredAtDataTimestamp);
            this.dateStartAndEndLabel = this.translationService.t("Alerts.FromStartToNow", [formattedStartDate]);
            return;
        }
        if (this.dateService.getDiff(this.incident.AlertRecord.TriggeredAtDataTimestamp, this.incident.AlertRecord.ClosedAtDataTime, DateUnit.Sec) === 0) {
            this.dateStartAndEndLabel = this.dateService.formatDate(this.incident.AlertRecord.TriggeredAtDataTimestamp, { dateTime: true });
            this.dateStartIsEqualToEnd = true;
        } else {
            this.dateStartAndEndLabel = this.dateService.formatDatesFromAndTo(this.incident.AlertRecord.TriggeredAtDataTimestamp, this.incident.AlertRecord.ClosedAtDataTime);
        }
    }

    private getAlertRecords(): void {
        if (!this.incident.AlertRuleId && !this.incident.AlertRecordId) {
            return;
        }
        const alertRulePromise = this.incident.AlertRuleId ? this.alertsService.getAlertRule(this.incident.AlertRuleId) : null;
        const alertRecordPromise = this.incident.AlertRecordId ? this.alertsService.getAlertRuleRecord(this.incident.AlertRecordId, AlertRecordMaterialisationOptions.WithMetadata) : null;

        this.$q.all([alertRulePromise, alertRecordPromise]).then(([rule, record]) => {
            this.incident.AlertRule = rule;
            this.incident.AlertRecord = record;


            this.category = this.translationService.tEnum(AlertCategory, 'AlertCategory', this.incident.AlertRule.Category);
            const { subCategoryEnum, subCategoryString } = this.alertsService.getAlertRuleSubcategoryEnum(this.incident.AlertRule.Category);
            this.subCategory = this.translationService.tEnum(subCategoryEnum, subCategoryString, this.incident.AlertRule.SubCategory);

            this.alertsService.parseAlertRecordMetadata(this.incident.AlertRecord);


            if (this.incident.AlertRecord.alertMetadata) {
                this.loadPlot();
            };
            this.getAllPlotsForAlert();
            this.getResolution();
            this.getDateStartAndEndLabel();
            this.setupPageElements();
            this.setupTimeline();
        });
    }

    private loadPlot() {
        if (!this.incident.AlertRecord) {
            return;
        }
        this.plotService.getPlot(this.incident.VehicleId, this.incident.AlertRecord.alertMetadata.PlotId).then(plot => {
            if (!plot) {
                return;
            }
            this.incident.AlertRecord.plot = plot;
            this.mapCenter = new CoordsModel(this.incident.AlertRecord.plot.Latitude, this.incident.AlertRecord.plot.Longitude);
        });
    }

    private getAllPlotsForAlert() {
        const startTime = new Date(this.incident.StartTime);
        const endTime = this.incident.AlertRecord.ClosedAtDataTime ? this.dateService.addOrSubtractTime(this.incident.AlertRecord.ClosedAtDataTime, 1, DateUnit.Min) : new Date();
        this.plotService.getPlotsForDateRange(this.incident.VehicleId, startTime, endTime).then(plots => {
            if (plots.length > 1 && plots.some(plot => plot.Velocity > 0)) {
                const endLabel = this.incident.AlertRecord.ClosedAtDataTime ? this.translationService.t("Alerts.AlertEnd") : this.translationService.t("Alerts.CurrLocationOngoing");
                const endIcon = this.incident.AlertRecord.ClosedAtDataTime ? "flag" : "directions_car";
                this.alertPolyline = this.mapService.createPolylineFromPlots(plots);
                this.alertLocationMarker = this.mapService.createMapMarker(plots[0], { label: this.translationService.t("Alerts.AlertLocation"), subIcon: "play_arrow", showLabel: true });
                this.endMapMarker = this.mapService.createMapMarker(plots.slice(-1)[0], { label: endLabel, subIcon: endIcon, showLabel: true });
                this.showMapMarkers = true;
            }
        });
    }

    private isAlarmOutsideActiveTimeRange(): boolean {

        if (!this.incident.AlertRecord || !this.incident.AlertRule || !this.incident.AlertRule?.AlertRuleExclusionTimePeriods) {
            return;
        }
        const incidentDayOfWeek = new Date(this.incident.AlertRecord.TriggeredAtDataTimestamp).getDay();
        const alertRestrictions = this.incident.AlertRule.AlertRuleExclusionTimePeriods.find(period => {
            return period.DayOfWeek === incidentDayOfWeek;
        });

        if (!alertRestrictions) {
            return false;
        }

        const alarmTime = new Date(this.incident.AlertRecord.TriggeredAtDataTimestamp);

        const rationalisedStart = new Date(alertRestrictions.StartTimeAdjusted);
        const rationalisedEnd = new Date(alertRestrictions.EndTimeAdjusted);

        if (this.dateService.date1IsAfterDate2(rationalisedEnd, rationalisedStart)) {
            return this.dateService.date1IsAfterDate2(alarmTime, rationalisedStart) && this.dateService.date1IsAfterDate2(rationalisedEnd, alarmTime);
        }

        return this.dateService.date1IsAfterDate2(alarmTime, rationalisedStart) || this.dateService.date1IsAfterDate2(rationalisedEnd, alarmTime);
    }


    private setupTimeline(): void {
        this.timelineEntries = [];
        if (!this.incident || !this.incident.AlertRecord || !this.incident.AlertRule) {
            return;
        }

        let alertRuleHasDelay = false;

        if (this.incident.AlertRule.FirstNotificationDelay > 0) {
            alertRuleHasDelay = true;
        }

        const alertSendTime: Date = new Date(this.incident.StartTime);
        const alarmStartTime: Date = new Date(this.incident.AlertRecord.TriggeredAtDataTimestamp);

        // Alarm Start

        const alarmStartTimelineEntry: ITimelineEntry = {
            icon: "report",
            date: new Date(alarmStartTime),
            largeDetails: {
                title: this.translationService.t("Alerts.AlarmStarted"),
                listItems: [{
                    verb: `${this.category} ${this.subCategory ? ' > ' + this.subCategory : ''}`
                }]
            }
        }

        if (this.isAlarmOutsideActiveTimeRange()) {
            alarmStartTimelineEntry.largeDetails.listItems.push({
                verb: this.translationService.t("Alerts.AlarmOutsideTimeRange")
            })
        }

        this.timelineEntries.push(alarmStartTimelineEntry);

        // Alert Start

        const firstNotificationSentTimelineEntry: ITimelineEntry = {
            icon: "notifications",
            date: new Date(alertSendTime),
            largeDetails: {
                title: this.translationService.t("Alerts.NotificationFirstSent"),
                listItems: [{
                    verb: this.translationService.t("Alerts.AlarmSentToRecipients", this.incident.AlertRule.Recipients?.length)
                }]
            }
        }

        if (this.isAlarmOutsideActiveTimeRange()) {
            firstNotificationSentTimelineEntry.largeDetails.listItems.unshift({
                verb: this.translationService.t("Alerts.DelayedByTimeRange")
            })
        }

        if (alertRuleHasDelay) {
            firstNotificationSentTimelineEntry.largeDetails.listItems.unshift({
                verb: this.translationService.t("Alerts.DelayedByMinutes", this.incident.AlertRule.FirstNotificationDelay)
            })
        }

        this.timelineEntries.push(firstNotificationSentTimelineEntry);

        // Alert resend

        if (this.incident.AlertRule?.ResendAlerts && this.incident.AlertRecord.SentCount > 1) {
            const mostRecentNotificationSentTimelineEntry: ITimelineEntry = {
                icon: "notifications",
                date: new Date(String(this.incident.AlertRecord.LastSent)),
                largeDetails: {
                    title: this.translationService.t("Alerts.MostRecentNotification"),
                    listItems: [{
                        verb: this.translationService.t("Alerts.ResendsOn")
                    },
                    {
                        verb: this.translationService.t("Alerts.AlertSentCount", this.incident.AlertRecord.SentCount)
                    }]
                }
            }


            this.timelineEntries.push(mostRecentNotificationSentTimelineEntry);
        }
        // Alarm end time
        if (this.incident.AlertRecord.ClosedAtDataTime) {
            this.timelineEntries.push({
                icon: "stop",
                date: this.incident.AlertRecord.ClosedAtDataTime as Date,
                largeDetails: {
                    title: this.translationService.t("Alerts.AlarmEnded"),
                }
            });
        }

        if (this.incident.AlertReviewEvents.length) {
            this.incident.AlertReviewEvents.forEach(event => {
                let icon = "update";
                let listItems: { verb: string; date?: Date }[] = [];
                let text: string = '';

                if (event.Notes) {
                    text = event.Notes;
                }

                if (event.ResolutionCodeId && event.Status === AlertReviewStatus.Closed) {
                    icon = "check_circle";
                    listItems.push({
                        verb: this.resolutionCodes.find(code => code.Id === event.ResolutionCodeId).Name,
                    });
                }

                this.timelineEntries.push({
                    icon: icon,
                    date: event.CreatedTime,
                    largeDetails: {
                        title: `${this.translationService.t("Alerts.ResolvedBy")} ${event.User?.CurrentAccountUserMapping?.Name ||
                            this.translationService.t("Common.UnknownUser")}`,
                        text: text,
                        listItems: listItems
                    }
                });
            });

        }
    }
}

export class IncidentDetailComponent implements angular.IComponentOptions {
    bindings: any;
    controller: any;
    template: any;

    constructor() {
        this.bindings = {
            incidentId: "<"
        };

        this.controller = IncidentDetailComponentComponentController;
        this.template = require("./incidentDetail.component.html");
    }
}

